import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Globe2, Compass, Layers } from "lucide-react";
import { BRANDING_TIERS } from "../data/brandingAgencies";

const ICONS = {
  national: Compass,
  international: Globe2,
  anthropology: Layers,
};

export default function BrandingHub() {
  return (
    <div className="min-h-screen bg-[#0A1128] pt-28 pb-20" data-testid="branding-hub-page">
      <div className="max-w-7xl mx-auto px-6">
        <nav className="text-xs text-slate-500 flex items-center gap-2 mb-6">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <span>/</span>
          <span className="text-[#B8D0EE]">Branding</span>
        </nav>

        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-[#7DA3D9]/25 bg-[#7DA3D9]/5 mb-6">
              <Sparkles className="w-3.5 h-3.5 text-[#7DA3D9]" />
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#B8D0EE] font-semibold">
                Branding · Three tiers
              </span>
            </div>
            <h1 className="font-display text-4xl lg:text-7xl tracking-tight leading-[0.98]" data-testid="branding-hub-title">
              Build a <span className="text-[#7DA3D9]">brand</span> that travels.
            </h1>
          </div>
          <div className="lg:col-span-4">
            <p className="text-slate-300 leading-relaxed text-lg">
              The branding partners every composer, songwriter, label, and publisher needs —
              organized into three deep tiers: <span className="text-[#B8D0EE]">National</span>,{" "}
              <span className="text-[#B8D0EE]">International</span>, and the foundational{" "}
              <span className="text-[#B8D0EE]">Branding Anthropology</span> framework studios.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-6" data-testid="branding-tiers-grid">
          {Object.entries(BRANDING_TIERS).map(([slug, t]) => {
            const Icon = ICONS[slug];
            return (
              <Link
                key={slug}
                to={`/branding/${slug}`}
                className="glass-card p-8 group flex flex-col"
                data-testid={`branding-tier-${slug}`}
              >
                <div className="w-12 h-12 rounded-md border border-[#7DA3D9]/30 bg-[#7DA3D9]/5 flex items-center justify-center mb-5">
                  <Icon className="w-6 h-6 text-[#7DA3D9]" />
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#7DA3D9] font-semibold">
                  {t.overline}
                </div>
                <h3 className="font-display text-2xl lg:text-3xl mt-2 group-hover:text-[#B8D0EE] transition-colors">
                  {t.label}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed mt-4 flex-1">{t.intro}</p>
                <div className="mt-5 text-xs text-[#7DA3D9] inline-flex items-center gap-1.5 font-semibold">
                  Browse {t.entries.length} entries <ArrowRight className="w-3.5 h-3.5" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
